import {ReactComponent as SelectionImg} from "./img/selection.svg";
import {ReactComponent as SharingImg} from "./img/sharing.svg";
import {ReactComponent as SelectionActiveImg} from "./img/selection-active.svg";
import {ReactComponent as BtnUp} from "./img/icon-arrow_up.svg";
import {ReactComponent as WatchLinkArrow} from "./img/movie-link-arrow.svg";

import React, {useEffect, useRef, useState} from "react";
import styles from "./movies.module.css";
import texts from "../../assets/ContextProvider/textsLocalized.json";
import {useNavigate} from "react-router-dom";
import Routes from "../../assets/Routes/Routes";
import 'simplebar/dist/simplebar.min.css';
import SimpleBar from 'simplebar-react';
import ServerRequest from "../../serverRequests/ServerRequest";
import {useSelector} from "react-redux";
import {scrollToTop} from "../../assets/AdditionalFunctions/ScrollToTop";
import {isIOS} from "../../assets/AdditionalFunctions/DefineDeviceSystem";
import {animateButtonPress} from "../../assets/AdditionalFunctions/AnimateButtonPress";
import {handleFormatReleaseDate} from "../../assets/AdditionalFunctions/FormattingMovieReleaseDate";
import WatchMoviePopup from "../../components/WatchMoviePopup/WatchMoviePopup";


const Movies = () => {
  const allMoviesCards = useSelector((state) => state.movies ?? []);

  const navigate = useNavigate();
  const [moviesCards, setMoviesCards] = useState([]);
  const [chosenCards, setChosenCards] = useState([]);
  const [isMoreVisible, setIsMoreVisible] = useState(true);
  const timerInfoPopup = useRef(null);
  const infoPopupRef = useRef(null);
  const [popupIndex, setPopupIndex] = useState(null);
  const sixthCardRef = useRef(null);
  const [showBtnUp, setShowBtnUp] = useState(false);
  const lastScrollY = useRef(0);
  const isScrollingUp = useRef(false);
  const userHash = localStorage.getItem("userHash");
  const timerInfoPopupWarning = useRef(null);
  const infoPopupWarningRef = useRef(null);
  const [popupWarningIndex, setPopupWarningIndex] = useState(null);
  const [shareUrl, setShareUrl] = useState(null);
  const [iosPopupIndex, setIosPopupIndex] = useState(null);
  const btnMoreRef = useRef(null);
  const btnFinishRef = useRef(null);
  const [isVisibleLinksPopup, setVisibleLinksPopup] = useState(false);
  const [linksPopupMovie, setLinksPopupMovie] = useState(null);
  const existsLocalPlatforms = ['Netflix', 'HBO', 'AppleTV', 'Amazon', 'YouTube', 'Disney+', 'Prime Video', 'AppleTV+', 'Rakuten TV', 'VUDU'];


  useEffect(() => {
    setMoviesCards(allMoviesCards.slice(0, 3));
  }, []);


  const handleChooseCard = async (index) => {
    const favoriteCard = {...moviesCards[index]};
    const movieId = favoriteCard['name'].concat(favoriteCard['releaseDate']);
    favoriteCard['id'] = movieId;

    const isAlreadyChosen = chosenCards.includes(index);

    setChosenCards(prev => {
      if (isAlreadyChosen) {
        return prev.filter((idx) => idx !== index);
      } else {
        return [...prev, index];
      }
    });

    try {
      let response;
      if (!isAlreadyChosen) {
        response = await ServerRequest.addFavoriteMovie(userHash, favoriteCard);
      } else {
        response = await ServerRequest.removeFavoriteMovie(userHash, movieId);
      }

      const result = await response.json();

      if (result.code === 401 && result["count_favorites"] >= 50) {
        setPopupWarningIndex(index);
        setChosenCards(prev => prev.filter((idx) => idx !== index));
      }

      if (!response.ok || result.code !== 200) {
        throw new Error(result.message || 'Failed to update favorite');
      }
    } catch (error) {
      console.error('Favorite error:', error);
    }
  }


  useEffect(() => {
    scrollToTop();
  }, []);


  useEffect(() => {
    timerInfoPopupWarning.current = setTimeout(() => {
      setPopupWarningIndex(null);
    }, 2500);

    return () => {
      clearTimeout(timerInfoPopupWarning.current);
    }
  }, [popupWarningIndex]);


  const handleLoadCards = async () => {
    await animateButtonPress(btnMoreRef, styles.pressed);

    if (allMoviesCards.length >= moviesCards.length + 3) {
      setMoviesCards(allMoviesCards.slice(0, moviesCards.length + 3));
    } else if (allMoviesCards.length >= moviesCards.length + 2) {
      setMoviesCards(allMoviesCards.slice(0, moviesCards.length + 2));
    } else if (allMoviesCards.length >= moviesCards.length + 1) {
      setMoviesCards(allMoviesCards.slice(0, moviesCards.length + 1));
    } else {
      setMoviesCards(allMoviesCards);
    }
  }


  useEffect(() => {
    if (moviesCards.length === allMoviesCards.length) {
      setIsMoreVisible(false);
    } else {
      setIsMoreVisible(true);
    }
  }, [moviesCards]);


  const handleIosCopySharedLink = async () => {
    if (shareUrl) {
      if (
        typeof navigator !== 'undefined' &&
        navigator.clipboard &&
        typeof navigator.clipboard.writeText === 'function'
      ) {
        try {
          await navigator.clipboard.writeText(shareUrl);
          infoPopupRef.current.classList.add(styles['movie-sharing-info-popup-ios-active']);

          setTimeout(() => {
            setIosPopupIndex(null);
          }, 300);

          console.log('Text copied to clipboard');
        } catch (err) {
          console.error('Failed to copy text: ', err);
        }
      } else {
        console.warn('Clipboard API not supported');

        const textarea = document.createElement('textarea');
        textarea.value = shareUrl;
        textarea.style.position = 'fixed';  // не дозволяє прокрутку до цього елемента
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();

        try {
          const successful = document.execCommand('copy');
          console.log(successful ? 'Text copied using execCommand' : 'execCommand failed');
        } catch (err) {
          console.error('execCommand failed:', err);
        }

        infoPopupRef.current.classList.add(styles['movie-sharing-info-popup-ios-active']);

        setTimeout(() => {
          setIosPopupIndex(null);
        }, 300);

        document.body.removeChild(textarea);
      }
    }
  };


  const handleShowExplanation = async (index) => {
    const selectedMovie = moviesCards[index];

    try {
      let serverData = await ServerRequest.createShareLinkData(selectedMovie, userHash);
      let parsedServerData = await serverData.json();

      if (!serverData.ok) {
        alert(parsedServerData.message || "Error sharing movie");
        return;
      }

      const url = `${window.location.origin}/shared/${parsedServerData.token}`;
      setShareUrl(url);

      if (isIOS()) {
        setIosPopupIndex(index);
      } else {
        setPopupIndex(index);
        try {
          await navigator.clipboard.writeText(url);
          // console.log("Link is copied to clipboard");
        } catch (err) {
          console.error("Clipboard error:", err);
        }
      }
    } catch (error) {
      console.error("Share error:", error);
    }
  };


  useEffect(() => {
    timerInfoPopup.current = setTimeout(() => {
      setPopupIndex(null);
    }, 2500);

    return () => {
      clearTimeout(timerInfoPopup.current);
    }
  }, [popupIndex]);


  useEffect(() => {
    const handleClickOutside = (e) => {
      if (infoPopupRef.current && !infoPopupRef.current.contains(e.target)) {
        setIosPopupIndex(null);
      }
    };

    document.addEventListener("pointerdown", handleClickOutside);
    return () => {
      document.removeEventListener("pointerdown", handleClickOutside);
    };
  }, []);


  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      isScrollingUp.current = currentScrollY < lastScrollY.current;
      lastScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShowBtnUp(true);
        } else if (isScrollingUp.current) {
          setShowBtnUp(false);
        }
      },
      {
        root: null,
        threshold: 0.5,
      }
    );

    if (sixthCardRef.current) {
      observer.observe(sixthCardRef.current);
    }

    return () => {
      if (sixthCardRef.current) {
        observer.unobserve(sixthCardRef.current);
      }
    };
  }, [moviesCards]);


  const scrollToTopForArrow = () => {
    window.scrollTo(
      {
        top: 0,
        behavior: 'smooth'
      }
    );
    setShowBtnUp(false);
  };


  const handleNavigate = async () => {
    await animateButtonPress(btnFinishRef, styles.pressed);
    navigate(Routes.welcome);
  }


  // useEffect(() => {
  //   const body = document.querySelector('body');
  //
  //   if (isVisibleLinksPopup) {
  //     body.classList.add(styles['non-pointer-link']);
  //   } else {
  //     body.classList.remove(styles['non-pointer-link']);
  //   }
  // }, [isVisibleLinksPopup]);


  useEffect(() => {
    const body = document.body;

    if (isVisibleLinksPopup) {
      const scrollY = window.scrollY;
      body.style.position = "fixed";
      body.style.top = `-${scrollY}px`;
      body.style.left = "0";
      body.style.right = "0";
      body.dataset.scrollY = scrollY;
    } else {
      const scrollY = body.dataset.scrollY;
      body.style.position = "";
      body.style.top = "";
      body.style.left = "";
      body.style.right = "";
      window.scrollTo(0, parseInt(scrollY || "0"));
    }
  }, [isVisibleLinksPopup]);


  return (
    <section className={styles["movies-container"]}>
      <p className={styles['movies-title']}>
        {texts.movies['movies_title']}</p>
      <p className={styles['movies-subtitle-warning']}>
        {texts.movies['movies_subtitle_warning']}</p>
      <div className={styles['movies-cards']}>
        {showBtnUp && (
          <div className={styles["btn-up-global"]}>
            <BtnUp className={styles["btn-up"]}
                   onClick={scrollToTopForArrow}/>
          </div>
        )}
        {moviesCards.map((movie, index) => {
          const isSixth = index === 5;
          return (
            <div className={styles['movie-card']}
                 key={index}
                 ref={isSixth ? sixthCardRef : null}>
              <div className={styles['movie-first-block']}>
                <img className={styles['movie-poster']}
                     src={movie["poster_url"] !== null ? movie["poster_url"]
                       :
                       require("./img/no-poster.png")}
                     alt="image poster"/>
                <div className={styles['movie-first-block-description']}>
                  <div>
                    <div className={styles["movie-first-section"]}>
                      <p className={styles['first-block-description-title']}>
                        {movie.name.length < 40 ? movie.name
                          : movie.name.substring(0, 40).concat('...')}
                      </p>
                      <div className={styles['first-block-interactions']}>
                        {
                          !chosenCards.includes(index) ?
                            <SelectionImg className={styles['movie-selection']}
                                          onClick={(e) => handleChooseCard(index, e)}/>
                            :
                            <SelectionActiveImg className={styles['movie-selection']}
                                                onClick={(e) => handleChooseCard(index, e)}/>
                        }
                        {popupWarningIndex === index &&
                          <div ref={infoPopupWarningRef}
                               className={styles["movie-selection-info-popup"]}>
                              <span className={styles["info-popup-selection-description"]}>
                                {texts.movies["warning-limit-info-popup"]}
                              </span>
                          </div>
                        }
                        <div className={styles['movie-sharing-container']}>
                          <SharingImg className={styles['movie-sharing']}
                                      onClick={() => handleShowExplanation(index)}/>
                          {popupIndex === index &&
                            <div ref={infoPopupRef}
                                 className={styles["movie-sharing-info-popup"]}>
                              <span className={styles["info-popup-description"]}>
                                {texts.movies["sharing-info-popup"]}
                              </span>
                            </div>
                          }
                          {(iosPopupIndex === index) && shareUrl && (
                            <div ref={infoPopupRef}
                                 onClick={handleIosCopySharedLink}
                                 className={styles["movie-sharing-info-popup-ios"]}>
                              <span className={styles["info-popup-description"]}>
                                {texts.movies["sharing-info-popup-ios"]}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={styles["movie-third-section"]}>
                    {movie.genres.map((genre, index) => {
                      return (
                        <div className={styles['movie-genre']} key={index}>{genre}</div>)
                    }).slice(0, 3)}
                  </div>
                  <div className={`${styles["watch-link-container"]}
                        ${(!movie.watchLinks ||
                    (!movie.watchLinks.some(link => existsLocalPlatforms.includes(link.platform)))
                  ) ? styles["watch-link-container-hidden"] : null}`}
                       onClick={() => {
                         setVisibleLinksPopup(true);
                         setLinksPopupMovie(movie.watchLinks);
                       }}
                  >
                    <p className={styles['watch-link-description']}>
                      {texts.movies['movies-watch-link']}
                    </p>
                    <div className={styles["watch-link-arrow-container"]}>
                      <WatchLinkArrow className={styles['movie-watch-link-arrow']}/>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles['movie-second-block']}>
                <div className={styles["movie-second-block--first"]}>
                  <div className={styles["movie-second-section"]}>
                    <div className={styles['director-info-container']}>
                      <p className={styles['director-info-title']}>
                        {texts.movies['movies-director']}:
                        <span className={styles['director-info-title-value']}>
                        {movie.director ? movie.director : 'not found'}
                      </span>
                      </p>
                    </div>
                    <div className={styles['release-date-info-container']}>
                      <p className={styles['release-date-title']}>
                        {texts.movies['movies-release-date']}:
                        <span className={styles['release-date']}>
                              {handleFormatReleaseDate(movie.releaseDate)}
                            </span>
                      </p>
                    </div>
                  </div>
                </div>
                <div className={styles["movie-second-block--second"]}>
                  <div className={styles['movie-duration']}>
                  <span className={styles['movie-duration-title']}>
                    {texts.movies['movies-duration-title']}:
                  </span>
                    <span className={styles['movie-duration-value']}>
                    {movie.duration ? movie.duration : 'not found'}
                  </span>
                  </div>
                  <div className={styles['movie-rating']}>
                  <span className={styles['movie-rating-title']}>
                    {texts.movies['movies-rating-title']}:
                  </span>
                    <span className={styles['movie-rating-value']}>
                  {Number(movie.ratingIMDb.toFixed(1))}
                  </span>
                    <img className={styles['movie-rating-star']}
                         src={require("./img/rating.png")}
                         alt="image rating star"/>
                  </div>
                </div>
              </div>
              <div className={styles['movie-third-block']}>
                <p className={styles['main-actors']}>
                  {texts.movies['main-actors-title']}: {(movie.mainActors.length < 1) &&
                  <span className={styles['not-found']}>not found</span>}
                </p>
                <p className={styles['movie-actor']}>
                  {movie.mainActors ? movie.mainActors.join(", ") : null}
                </p>
              </div>
              <div className={styles['movie-fourth-block']}>
                <p className={styles['review']}>
                  {texts.movies['review']}: {!movie.review &&
                  <span className={styles['not-found']}>not found</span>}
                </p>
                {(movie.review && movie.review.length > 240) ?
                  <SimpleBar className={styles['movie-review']}>
                    {movie.review ? movie.review : 'not found'}
                  </SimpleBar> :
                  (movie.review && movie.review.length <= 240) ?
                    <div
                      className={styles['movie-review-without-scroll']}>
                      {movie.review ? movie.review : 'not found'}
                    </div> : null
                }
              </div>
            </div>
          )
        })}
      </div>
      <button ref={btnMoreRef}
              className={
                `${styles['more-button']}
         ${!isMoreVisible ? `${styles['hidden']}` : ""}`}
              onClick={handleLoadCards}>
        {texts.movies['btn-more']}
      </button>
      <p className={`${styles['movies-part-count']}
                     ${!isMoreVisible ? `${styles['hidden']}` : ""}`}>
        {moviesCards.length / 3}/{Math.ceil(allMoviesCards.length / 3)}
      </p>
      <p className={`${styles['notice-finished']}
                     ${isMoreVisible ? `${styles['hidden']}` : ""}`}>
        {texts.movies['notice-finished']}
      </p>
      <button ref={btnFinishRef}
              className={styles['finish-button']}
              onClick={handleNavigate}>
        {texts.movies['btn-finish']}
      </button>

      {isVisibleLinksPopup &&
        <WatchMoviePopup linksData={linksPopupMovie}
                         isVisible={isVisibleLinksPopup}
                         handleVisibility={setVisibleLinksPopup}/>}
    </section>
  )
}

export default Movies;